import { render } from "./MetalPlayer.vue?vue&type=template&id=4a35f32a&scoped=true"
import script from "./MetalPlayer.vue?vue&type=script&lang=js"
export * from "./MetalPlayer.vue?vue&type=script&lang=js"

import "./MetalPlayer.vue?vue&type=style&index=0&id=4a35f32a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a35f32a"]])

export default __exports__